import { render } from "./QuotationUploadModal.vue?vue&type=template&id=2755a4b8"
import script from "./QuotationUploadModal.vue?vue&type=script&lang=js"
export * from "./QuotationUploadModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__